import React, { Component } from 'react';
class AdminPrinterInfo extends Component {
    state = {}
    render() {
        let printer = this.props.printer
        let baudrates = []
        let ports = []
        let profiles = []
        if (Object.keys(printer.connection).length != 0) {
            printer.connection.options.baudrates.forEach((baud, i) => {
                baudrates.push(<li> connection option baudrates {i}: {baud}</li>)
            });
            printer.connection.options.ports.forEach((port, i) => {
                ports.push(<li> connection option ports {i}: {port}</li>)
            });
            printer.connection.options.printerProfiles.forEach((printerProfile, i) => {
                profiles.push(<li> connection option printerProfiles {i}: {printerProfile.id} : {printerProfile.name}</li>)
            });
        }
        return (
            <div style={{ height: "100%", width: "80vw" }} >
                <li>

                    start_gcode: {printer.printer.start_gcode}
                </li>

                <li>

                    end_gcode: {printer.printer.end_gcode}
                </li>

                <div>
                    {printer.printer.error && "Error:" + printer.printer.error}



                    <li>
                        printerConnected: {printer.printer.connected ? "true" : "false"}
                    </li>
                    {(Object.keys(printer.info).length != 0) &&
                        <div>
                            <li>
                                text: {printer.info.state && printer.info.state.text}
                            </li>
                            <li>
                                ready: {printer.info.state.flags.ready ? "True" : "false"}
                            </li>
                        </div>
                    }


                </div>


                <li>
                    api_key: {printer.printer.api_key}
                </li>
                <li>
                    print_bed_x: {printer.printer.print_bed_x}
                </li>
                <li>
                    print_bed_y: {printer.printer.print_bed_y}
                </li>
                <li>
                    print_bed_z: {printer.printer.print_bed_z}
                </li>


                <hr />
                {(Object.keys(printer.info).length != 0) &&
                    <div>
                        <li>
                            sd ready: {printer.info.sd.ready ? "True" : "False"}
                        </li>
                        <li>
                            error: {printer.info.state.error}
                        </li>

                        <li>
                            cancelling: {printer.info.state.flags.cancelling ? "True" : "false"}
                        </li>
                        <li>
                            closedOrError: {printer.info.state.flags.closedOrError ? "True" : "false"}
                        </li>
                        <li>
                            error: {printer.info.state.flags.error ? "True" : "false"}
                        </li>
                        <li>
                            finishing: {printer.info.state.flags.finishing ? "True" : "false"}
                        </li>
                        <li>
                            operational: {printer.info.state.flags.operational ? "True" : "false"}
                        </li>
                        <li>
                            paused: {printer.info.state.flags.paused ? "True" : "false"}
                        </li>
                        <li>
                            pausing: {printer.info.state.flags.pausing ? "True" : "false"}
                        </li>
                        <li>
                            printing: {printer.info.state.flags.printing ? "True" : "false"}
                        </li>

                        <li>
                            resuming: {printer.info.state.flags.resuming ? "True" : "false"}
                        </li>
                        <li>
                            sdReady: {printer.info.state.flags.sdReady ? "True" : "false"}
                        </li>



                        <li>
                            W Actual temperature: {printer.info.temperature.W && printer.info.temperature.W.actual}
                        </li>
                        <li>
                            W offset temperature: {printer.info.temperature.W && printer.info.temperature.W.offset}
                        </li>
                        <li>
                            W Target temperature: {printer.info.temperature.W && printer.info.temperature.W.target}
                        </li>
                        {printer.info.temperature.bed && <div>

                            <li>
                                bed offset temperature: {printer.info.temperature.bed.offset}
                            </li>
                        </div>}
                        {printer.info.temperature.tool0 && <div>

                            <li>
                                tool0 offset temperature: {printer.info.temperature.tool0.offset}
                            </li>
                        </div>}
                    </div>
                }
                <hr></hr>
                {(Object.keys(printer.job).length != 0) &&

                    <div>
                        <li>
                            job average print time: {printer.job.job.averagePrintTime}
                        </li>
                        <li>
                            job estimated print time: {printer.job.job.estimatedPrintTime}
                        </li>
                        <li>
                            job filimant tool 0 length: {printer.job.job.filament && printer.job.job.filament.tool0 && printer.job.job.filament.tool0.length}
                        </li>
                        <li>
                            job filimant  tool 0 volume: {printer.job.job.filament && printer.job.job.filament.tool0 && printer.job.job.filament.tool0.volume}
                        </li>
                        <li>
                            job file date: {printer.job.job.file.date}
                        </li>
                        <li>
                            job file display: {printer.job.job.file.display}
                        </li>

                        <li>
                            job file origin: {printer.job.job.file.origin}
                        </li>
                        <li>
                            job file path: {printer.job.job.file.path}
                        </li>
                        <li>
                            job file size: {printer.job.job.file.size}
                        </li>
                        <li>
                            job last print time: {printer.job.job.lastPrintTime}
                        </li>
                        <li>
                            job user: {printer.job.job.user}
                        </li>
                        <li>
                            job progress filepos: {printer.job.progress.filepos}
                        </li>

                        <li>
                            job progress print time left origin: {printer.job.progress.printTimeLeftOrigin}
                        </li>
                    </div>
                }
                <hr></hr>
                {(Object.keys(printer.version).length != 0) &&
                    <div>
                        <li>
                            Version api: {printer.version.api}
                        </li>
                        <li>
                            Version server: {printer.version.server}
                        </li>
                        <li>
                            Version text: {printer.version.text}
                        </li>
                    </div>}
                <hr />
                {(Object.keys(printer.server).length != 0) &&
                    <div>
                        <li>
                            Server version: {printer.server.version}
                        </li>
                        <li>
                            server safemode: {printer.server.safemode}
                        </li>
                    </div>}
                <hr />
                {(Object.keys(printer.connection).length != 0) &&
                    <div>
                        <li>
                            connection current baudrate: {printer.connection.current.baudrate}
                        </li>
                        <li>
                            connection current port: {printer.connection.current.port}
                        </li>
                        <li>
                            connection current printerProfile: {printer.connection.current.printerProfile}
                        </li>
                        <li>
                            connection current state: {printer.connection.current.state}
                        </li>
                        <li>
                            connection options baudrate preference: {printer.connection.options.baudratePreference}
                        </li>
                        {baudrates}
                        <li>
                            connection options  portPreference: {printer.connection.options.portPreference}
                        </li>
                        {ports}
                        <li>
                            connection options  printerProfilePreference: {printer.connection.options.printerProfilePreference}
                        </li>
                    </div>}
                {profiles}
                <hr />
            </div>
        );
    }
}

export default AdminPrinterInfo;